import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const loc = useLocation();
  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        <main key={loc.pathname} className="flex-1 min-w-0 p-6 lg:p-8 max-w-[1600px] w-full mx-auto animate-in fade-in-50 duration-300">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
